module.exports = "<!--\n<page-topbar></page-topbar>\n<page-header></page-header>\n-->\n<!--\n<page-content></page-content>\n-->\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 681
// module chunks = 1